export default __webpack_public_path__ + "static/media/Rogers.d1ebdf1b.png";